import { lazy, Suspense } from 'react';
import FuseLoading from '@fuse/core/FuseLoading';

const AdminOffersPage = lazy(() => import('./AdminOffersPage'));

const AdminOffersConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'admin/offers',
      element: (
        <Suspense fallback={<FuseLoading />}>
          <AdminOffersPage />
        </Suspense>
      ),
    },
  ],
};

export default AdminOffersConfig;
